import styled from "styled-components";

// Jeśli wartość zaczyna się od "var(" — używamy jej bezpośrednio, inaczej dodajemy px (legacy)
const withUnit = (val: string) => val.startsWith('var(') ? val : `${val}px`;

export const P = styled.p<{ $size: string, $weight: string, $height: string, $family?: string }>`
    margin: 0;
    font-family: ${({ $family = 'Lato' }) => $family}, sans-serif;
    font-size: ${({ $size }) => withUnit($size)};
    font-weight: ${({ $weight }) => $weight};
    line-height: ${({ $height }) => withUnit($height)};
`;
